export default __webpack_public_path__ + "static/media/header_1440_KMI_generica_web_sep20.ac50113f.png";